<div class="demo">
  <pa-info-block blockTitle="Обычные вкладки">
    <p-tabs scrollable="true" [value]="activeTab1" (valueChange)="handleTabChange1($event)">
      <p-tablist>
        <pa-tab [value]="'tab1'">Вкладка 1</pa-tab>
        <pa-tab [value]="'tab2'">Вкладка 2</pa-tab>
        <pa-tab [value]="'tab3'">Вкладка 3</pa-tab>
      </p-tablist>
    </p-tabs>
  </pa-info-block>

  <pa-info-block blockTitle="С подсказкой">
    <p-tabs scrollable="true" [value]="activeTab7" (valueChange)="handleTabChange7($event)">
      <p-tablist>
        <pa-tab
          [value]="'tab1'"
          tooltip="Подсказка у активной вкладки"
        >
          Сотрудники
        </pa-tab>
        <pa-tab
          [value]="'tab2'"
          tooltip="Подсказка показывается при наведении и на неактивной вкладке"
        >
          Должности
        </pa-tab>
        <pa-tab [value]="'tab3'" tooltip="Краткое описание раздела">
          Отчеты
        </pa-tab>
      </p-tablist>
    </p-tabs>
  </pa-info-block>

  <pa-info-block blockTitle="С бейджем">
    <p-tabs scrollable="true" [value]="activeTab2" (valueChange)="handleTabChange2($event)">
      <p-tablist>
        <pa-tab [value]="'tab1'" [badge]="badgeValue">Сотрудники</pa-tab>
        <pa-tab [value]="'tab2'" [badge]="12">Должности</pa-tab>
        <pa-tab [value]="'tab3'" [badge]="108">Отчеты</pa-tab>
      </p-tablist>
    </p-tabs>
  </pa-info-block>

  <pa-info-block blockTitle="С загрузкой">
    <p-tabs scrollable="true" [value]="activeTab3" (valueChange)="handleTabChange3($event)">
      <p-tablist>
        <pa-tab [value]="'tab1'" [badge]="3" [loading]="loadingValue">
          Загрузка данных
        </pa-tab>
        <pa-tab [value]="'tab2'">Обычная вкладка</pa-tab>
      </p-tablist>
    </p-tabs>
    <div class="controls">
      <button (click)="toggleLoading()">
        {{ loadingValue ? 'Остановить загрузку' : 'Начать загрузку' }}
      </button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Профи вкладка">
    <p-tabs scrollable="true" [value]="activeTab6" (valueChange)="handleTabChange6($event)">
      <p-tablist>
        <pa-tab [value]="'tab1'" [isProfi]="true">Сотрудники</pa-tab>
        <pa-tab [value]="'tab2'" [badge]="12">Должности</pa-tab>
        <pa-tab [value]="'tab3'" [badge]="108">Отчеты</pa-tab>
      </p-tablist>
    </p-tabs>
  </pa-info-block>

  <pa-info-block blockTitle="Отключенная вкладка">
    <p-tabs scrollable="true" [value]="activeTab4" (valueChange)="handleTabChange4($event)">
      <p-tablist>
        <pa-tab [value]="'tab1'">Активная вкладка</pa-tab>
        <pa-tab [value]="'tab2'" [disabled]="true">Отключенная вкладка</pa-tab>
        <pa-tab [value]="'tab3'">Другая вкладка</pa-tab>
      </p-tablist>
    </p-tabs>
  </pa-info-block>

  <pa-info-block blockTitle="Комбинации">
    <p-tabs scrollable="true" [value]="activeTab5" (valueChange)="handleTabChange5($event)">
      <p-tablist>
        <pa-tab
          [value]="'tab1'"
          [badge]="3"
          tooltip="Вкладка с бейджем и подсказкой"
        >
          С бейджем
        </pa-tab>
        <pa-tab [value]="'tab2'" [badge]="99" [loading]="true">
          С бейджем и загрузкой
        </pa-tab>
        <pa-tab [value]="'tab3'" [badge]="3">С бейджем и загрузкой</pa-tab>
        <pa-tab [value]="'tab4'" [badge]="150">Большое число (99+)</pa-tab>
      </p-tablist>
    </p-tabs>
  </pa-info-block>

  <pa-info-block blockTitle="Вкладки с роутингом">
    <pa-router-tabs>
      <p-tablist>
        <pa-tab [isProfi]="true" [routerLink]="['/app/users']">
          Сотрудники
        </pa-tab>
        <pa-tab
          [badge]="3"
          [routerLink]="['/ui-kit']"
          tooltip="Страница UI Kit"
        >
          ui-kit
        </pa-tab>
        <pa-tab [routerLink]="['/app/pvzs']">Пункты выдачи</pa-tab>
      </p-tablist>
    </pa-router-tabs>
  </pa-info-block>
</div>
